import PaymentFinancialSummary from './PaymentFinancialSummary';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { subDays, format } from 'date-fns';
import PaymentConfiguration from './PaymentConfiguration';
import useActivationPaymentSettings, { PaymentRecord, PaymentReportData } from './hooks/useActivationPaymentSettings';
import PaymentReportSummary from './PaymentReportSummary';
import PaymentReportChart from './PaymentReportChart';
import PaymentRecordsTable from './PaymentRecordsTable';
import { DatePickerWithRange } from '@/src/shadComponents/ui/DateRangePicker';
export default function PaymentSettings() {
    const { activationId } = useParams();
    const { getPaymentReportData, getPaymentRecords } = useActivationPaymentSettings();
    const [range, setRange] = useState<{ from: Date; to: Date } | undefined>({ from: subDays(new Date(), 30), to: new Date() });
    const [report, setReport] = useState<PaymentReportData | null>(null);
    const [records, setRecords] = useState<PaymentRecord[]>([]);
    const [reload, setReload] = useState(0);
    const [error, setError] = useState('');
    useEffect(() => {
        let cancelled = false;
        if (!activationId || !range?.from || !range.to) return;
        setError('');
        const start = format(range.from, 'yyyy-MM-dd'), end = format(range.to, 'yyyy-MM-dd');
        Promise.all([getPaymentReportData(+activationId, start, end), getPaymentRecords(+activationId, start, end)])
            .then(([r, rows]) => { if (!cancelled) { setReport(r); setRecords(rows); if (!r) setError('Could not load payment reports.'); } })
            .catch(() => { if (!cancelled) setError('Could not load payment reports.'); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId, range, reload]);
    return <div className="mx-auto w-full max-w-6xl space-y-8 p-6">
        <PaymentConfiguration activationId={Number(activationId)} onSaved={() => setReload(n => n + 1)} />
        <div className="flex flex-wrap items-center justify-between gap-4">
            <div><h2 className="text-lg font-semibold">Payment activity</h2><p className="text-sm text-muted-foreground">Review sales, tax, and payments for the selected dates.</p></div>
            <DatePickerWithRange date={range} setDate={setRange} />
        </div>
        {error && <p role="alert">{error}</p>}
        {report && <><PaymentFinancialSummary report={report} /><PaymentReportSummary reportData={report} dateRange={range} /><PaymentReportChart reportData={report} /></>}
        <PaymentRecordsTable paymentRecords={records} />
    </div>;
}
